import { render, staticRenderFns } from "./EntityOfUserModal.vue?vue&type=template&id=b6de3bf2&scoped=true&"
import script from "./EntityOfUserModal.vue?vue&type=script&lang=js&"
export * from "./EntityOfUserModal.vue?vue&type=script&lang=js&"
import style0 from "./EntityOfUserModal.vue?vue&type=style&index=0&id=b6de3bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6de3bf2",
  null
  
)

export default component.exports